import React, { useState, useEffect } from "react";
import "../css/Common.css";
import { FaArrowUp } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";

const ChatButton = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 400) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="action_center_wrapper">
      
      {/* Orbital Quick Actions */}
      {/* <div className="orbital_actions">
        <AnimatePresence>
          {isOpen && (
            <>
              <motion.div
                initial={{ opacity: 0, y: 20, scale: 0 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                exit={{ opacity: 0, y: 20, scale: 0 }}
                transition={{ duration: 0.3, delay: 0.1 }}
              >
                <Link 
                  target="_blank" 
                  to={`https://wa.me/${phone.replace(/[^\d]/g, '')}`} 
                  className="action_node node_whatsapp"
                  title="WhatsApp Support"
                >
                  <FaWhatsapp />
                </Link>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20, scale: 0 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                exit={{ opacity: 0, y: 20, scale: 0 }}
                transition={{ duration: 0.3, delay: 0.2 }}
              >
                <Link 
                  target="_blank" 
                  to={`tel:${phone}`} 
                  className="action_node node_call"
                  title="Call Support"
                >
                  <IoCall />
                </Link>
              </motion.div>
            </>
          )}
        </AnimatePresence>

        <motion.div 
            className={`master_trigger ${isOpen ? 'active' : ''}`}
            onClick={() => setIsOpen(!isOpen)}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
        >
          <FaPlus />
        </motion.div>
      </div> */}

      {/* Scroll to Top */}
      <AnimatePresence>
        {showScrollTop && (
          <motion.div
            className="scroll_top_node"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 50 }}
            onClick={scrollToTop}
            whileHover={{ y: -5 }}
          >
            <FaArrowUp />
          </motion.div>
        )}
      </AnimatePresence>

    </div>
  );
};

export default ChatButton;
